import postRequest from '../../../../../../postRequest';

/**
 * Bulk upload a primary category.
 *
 * @param {number} SiteId Site Id
 * @param {number} SourceId Source Id
 * @param {file} File Either a csv or excel file
*/
export default function postPrimaryCategoryPluId({
  SiteId,
  SourceId,
  File,
}) {
  const endpoint = `/oc-product-bulkapi/v1/bulk-process/primary-category/plu-id/${SourceId}`;

  const body = new FormData();
  body.append('SiteId', SiteId);
  body.append('LanguageId', 0);
  body.append('File', File);

  return new Promise((resolve, reject) => {
    postRequest(
      endpoint,
      body,
      'Primary Category PLU Ids',
      'STARTED: Primary Category PLU Ids',
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}
